import type { RouteResources } from '@atlassian/react-resource-router';
/* eslint-disable import/order */
import { MenuIdFilters } from '@jira/navigation-apps__constants/src/MenuIdFilters.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LegacyPage } from '@jira/router-routes__common/src/ui/legacy-page/main.tsx';
import { globalIssueNavigatorBrowseRoute } from '@jira/router-routes__legacy-global-issue-navigator-routes/src/globalIssueNavigatorBrowseRoute.tsx';

export const globalIssueNavigatorBrowseRouteEntry: JiraLegacyRoute<RouteResources> =
	createLegacyEntry(globalIssueNavigatorBrowseRoute, () => ({
		canTransitionIn: () => false,
		// eslint-disable-next-line no-restricted-syntax
		component: LegacyPage,
		layout: globalLayout,
		navigation: {
			menuId: MenuIdFilters,
		},
		resources: [...getNavigationResources(), navigationSidebarGlobalResource],
	}));
